export default {
  computed: {
    checkIfImageIsVisible() {
      if ('hide_menu_item_images' in this.branding?.display_options) {
        if (this.branding?.display_options?.hide_menu_item_images) {
          return false
        }
      }
      return true
    },
  },
}
